module.exports = __webpack_public_path__ + "img/placeholder6-opti.cbebb148.png";